import { RewardVault } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike } from "ethers";

export const SetStakingToken = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  stakingToken: AddressLike,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).setStakingToken(stakingToken);

export const SetRewardToken = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  rewardToken: AddressLike,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).setRewardToken(rewardToken);

export const SetRewardFeeder = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  feeder: AddressLike,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).setRewardFeeder(feeder);

export const SetClaimWhitelist = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  claimer: AddressLike,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).setClaimWhitelist(claimer);

export const RevokeClaimWhitelist = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  claimer: AddressLike,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).revokeClaimWhitelist(claimer);

export const SetterMethods = {
  SetStakingToken,
  SetRewardToken,
  SetRewardFeeder,
  SetClaimWhitelist,
  RevokeClaimWhitelist,
};

export default SetterMethods;
